import React from 'react';
import AppRouter from './router/router';
// import logo from './logo.svg';
import './App.css';
import './antd-overrides.scss';

function App() {
  return (
    <div className="App">
      <AppRouter />
    </div>
  );
}

export default App;
